import React from "react";
import { faq } from "../../data/data";
import FaqItem from "./FaqItem";
import { FAQ } from "../../assets";
import Header from "../../components/Header";

const Faq = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-[2rem] min-h-screen">
      <Header title="Frequently Asked Questions (FAQ)" subtitle="Your comprehensive guide to understanding our services and policies" />
      <div className="grid grid-cols-2 justify-between gap-[50px]">
        <div className="hidden md:block bg-br">
          <img src={FAQ} className="w-[400px] h-full object-contain" alt="" />
        </div>
        <div className="w-full">
          {faq?.length ? faq?.map((f, i) => <FaqItem key={i} item={f} />) : ""}
        </div>
      </div>
    </div>
  );
};

export default Faq;
